export class Result {
    constructor(
        public title: string,
        public description: string,
        public date: string,
        public url: string,
        public details: Array<any>,
        public imageAlt: string,
        public imageUrl: string
    ){}
}